<ui-card>
    <app-segment-header title="{{ 'settings.indeed-form.jobPostingCardTitle' | translate }}"></app-segment-header>
    <mat-radio-group
        name="isIndeedJobSyncEnabled"
        [value]="isIndeedJobSyncEnabled"
        (change)="isIndeedJobSyncEnabled = $event.value; isIndeedJobSyncEnabledChange.emit($event.value)"
        required
        class="vertical"
    >
        <mat-label class="margin-bottom-1">{{ 'settings.indeed-form.jobPostingCardLabel' | translate }}</mat-label>
        <mat-radio-button [value]="true">{{
            'settings.indeed-form.jobPostingCardAutoPost' | translate
        }}</mat-radio-button>
        <mat-radio-button [value]="false">{{
            'settings.indeed-form.jobPostingCardDoNotAutoPost' | translate
        }}</mat-radio-button>
    </mat-radio-group>
</ui-card>
